module.exports = __webpack_public_path__ + "static/img/0002.5efeeac5.png";